
export const formatText  = (value, maxLength = 150) => {
  if (!value) return "";

  return value
    .trim()                  // remove start/end spaces
    .replace(/\s+/g, " ")    // replace multiple spaces with single
    .slice(0, maxLength);    // limit length (default 150)
};